import React, { useState, useRef, useEffect, Fragment } from "react";
import "./advertisementCardStyle.css";
import {
  Checkbox,
  FormControlLabel,
  TextField,
  Autocomplete,
  Box,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import UploadImageSvg from "../icons/UploadImageSvg";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import IconButton from "@mui/material/IconButton";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import ImageIcon from "@mui/icons-material/Image";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  updateAdvertisement,
  uploadAdvertisement,
  viewUploadFiles,
} from "./advertisementApi";
import Carousel from "../carousel/Carousel";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  setAdvertisementExpand,
  setHideHeader,
  setFontSize,
  setFontColor,
  setBackgroundColor,
  setReadyBgColor,
  setPrepareBg,
  setTemplateKOT,
  setFontBgPreColor,
  setDineinColor,
  setTakeawayColor,
  setDeliveryColor,
  setReadyDineinColor,
  setReadyTakeawayColor,
  setReadyDeliveryColor,
  setUseOrderTypeColors,
  setShowPreparingTimer,
  setShowHeaderDateTime,
  setEnableNewsScrollMedia,
  setNewsScrollItems,
  setTickerAnimationType,
  setPrepareColumnBgEnabled,
  setReadyColumnBgEnabled,
  setPrepareColumnBgOpacity,
  setReadyColumnBgOpacity,
  setPrepareColumnBgMediaIds,
  setReadyColumnBgMediaIds,
  setColumnBgIntervalMs,
} from "../../kotTokenDisplaySlice";
import {
  setDisplayAdvertisementData,
  setIsEditAdv,
  setLoading,
} from "./advertisementSlice";
import { setSelectedPosDevice, setSelectedPosDevices } from "../../kotTokenDisplaySlice";
import AlertMessage from "../../../FloorManagement/components/alertMessage/AlertMessage";
import videoIcon from "../icons/videoIcon.png";
import MediaDialog from "../dialog/PreviewDialog";
import EditIcon from "@mui/icons-material/Edit";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { switch_to_billing_screen } from "../../../Sales/Billing/newBillingSlice";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import { branchSettingsSingleView } from "../../../PointOfSale/Configuration/BranchSettings/BranchSettingsAPI";
import { viewPosSettingsAPICall } from "../../../PointOfSale/Configuration/Settings/posSettingsAPI";
import db from "../../../../../offline/db";
const AdvertisementCard = ({ toggleDisplayMode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails, branchDetails } = useSelector(
    (state) => state.mainDashBoardSlice
  );
  const companyProfileData = useSelector(
    (state) => state?.companyProfileSlice?.userValue
  );
  const { advertisementExpand, hideHeader } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
  const { displayAdvertisement, alertMessage, loading, isEditAdv } =
    useSelector((state) => state.advertisementSlice);
  const userRole = useSelector((state) => state.userRoleSlice.value);
  const allBranchesList = useSelector((state) => state.allBranchesSlice.value);
  const { fontSize, fontColor,prepareBG, backgroundColor ,readyBG,templatekot,prepareFontBG,
    dineinColor, takeawayColor, deliveryColor,
    readyDineinColor, readyTakeawayColor, readyDeliveryColor,
    useOrderTypeColors,
    showPreparingTimer,
    showHeaderDateTime,
    enableNewsScrollMedia,
    newsScrollItems,
    tickerAnimationType,
    prepareColumnBgEnabled,
    readyColumnBgEnabled,
    prepareColumnBgOpacity,
    readyColumnBgOpacity,
    prepareColumnBgMediaIds,
    readyColumnBgMediaIds,
    columnBgIntervalMs
  } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
  const fullBranchSettings = useSelector((state) => state.branchSettingsSliceNew?.rowData);
  const branchPosConfigurations = useSelector((state)=> state.branchSettingsSliceNew?.branchPosConfigurations);
  const billingConfig = useSelector((state)=> state.newBillingSlice?.branchConfigurationList);
  const posSettings = useSelector((state)=> state.posSettingSlice?.apiResList);
  const initialState = {
    branch: null,
    selectScreen: 1,
    files: [],
    duration: 1,
    deletedImageIds: [],
  };

  const [formData, setFormData] = useState(initialState);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [dialogData, setDialogData] = useState({
    status: false,
    url: null,
    format: null,
  });

  useEffect(() => {
    const { branch } = formData;
    if (branchDetails || branch) {
      dispatch(setDisplayAdvertisementData(null));
      viewUploadFiles({
        body: { branchId: branchDetails?._id || branch?._id },
      });
    }
  }, [branchDetails, formData?.branch]);

  // Ensure full branch settings (with posDevices) are loaded for the selector
  useEffect(() => {
    const devicesLoaded = Array.isArray(fullBranchSettings?.posDevices) && fullBranchSettings.posDevices.length > 0;
    if (!devicesLoaded && branchDetails?._id) {
      console.log('🔄 Fetching branch settings for Token Display with branchId:', branchDetails._id);
      // Use the correct API that accepts branchId and returns full settings including posDevices
      // The viewUserbranchSettings endpoint expects either _id OR branchId, not both
      // Since we don't have _id on first load, we use branchId
      branchSettingsSingleView({ branchId: branchDetails._id });
    }
  }, [branchDetails?._id, fullBranchSettings?.posDevices?.length]);

  // Restore POS device selection from localStorage on mount
  useEffect(() => {
    try {
      const savedMulti = window.localStorage.getItem("tokenDisplay.posDevices");
      // Load posDevices from localStorage as fallback when Redux is empty
      let localStorageDevices = [];
      try {
        const savedDevices = window.localStorage.getItem("branchSettings.posDevices");
        if (savedDevices) {
          localStorageDevices = JSON.parse(savedDevices);
          console.log('📂 Loaded', localStorageDevices.length, 'POS devices from localStorage');
        }
      } catch (e) {}
      
      const devices = [
        ...(fullBranchSettings?.posDevices || []),
        ...(Array.isArray(branchPosConfigurations?.posDevices) ? branchPosConfigurations.posDevices : []),
        ...(Array.isArray(billingConfig?.posDevices) ? billingConfig.posDevices : []),
        ...(Array.isArray(posSettings?.posDevices) ? posSettings.posDevices : []),
        ...localStorageDevices,
      ]
      .filter(Boolean)
      .reduce((acc, cur) => {
        if (!cur) return acc;
        const id = cur?._id || cur?.id;
        if (!id) return acc;
        if (!acc.some((x)=> (x?._id || x?.id) === id)) acc.push(cur);
        return acc;
      }, []);
      // Restore selection from localStorage if devices exist in current list
      if (savedMulti && devices.length > 0) {
        const parsedArr = JSON.parse(savedMulti);
        const selected = devices.filter((d) => parsedArr.includes(d?._id));
        if (selected.length > 0) {
          console.log('✅ Restoring', selected.length, 'device selection(s) from localStorage');
          setSelectedDevices(selected);
          dispatch(setSelectedPosDevices(selected.map((d) => d?._id)));
        } else {
          console.log('⚠️ Saved devices not found in current list, clearing selection');
          window.localStorage.removeItem("tokenDisplay.posDevices");
        }
      }
    } catch (_) {}
  }, [fullBranchSettings, branchPosConfigurations, billingConfig, posSettings]);

  // Fallback: if no devices available yet, fetch POS settings which also contains posDevices
  useEffect(() => {
    const hasAnyDevices = [
      ...(fullBranchSettings?.posDevices || []),
      ...(Array.isArray(branchPosConfigurations?.posDevices) ? branchPosConfigurations.posDevices : []),
      ...(Array.isArray(billingConfig?.posDevices) ? billingConfig.posDevices : []),
      ...(Array.isArray(posSettings?.posDevices) ? posSettings.posDevices : []),
    ].filter(Boolean).length > 0;
    console.log('🔍 Token Display POS Devices Check:', {
      hasAnyDevices,
      fullBranchSettings_count: fullBranchSettings?.posDevices?.length || 0,
      branchPosConfigurations_count: branchPosConfigurations?.posDevices?.length || 0,
      billingConfig_count: billingConfig?.posDevices?.length || 0,
      posSettings_count: posSettings?.posDevices?.length || 0,
      posSettings_raw: posSettings
    });
    if (!hasAnyDevices) {
      console.log('⚠️ No devices found, calling viewPosSettingsAPICall()');
      viewPosSettingsAPICall();
    }
  }, [fullBranchSettings?.posDevices, branchPosConfigurations?.posDevices, billingConfig?.posDevices, posSettings?.posDevices]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const handleFontSizeChange = (newSize) => {
    dispatch(setFontSize(newSize));
    localStorage.setItem("fontSize", newSize);
    
  };

  const handleTemplateChange = (newTem) => {
    dispatch(setTemplateKOT(newTem));
    localStorage.setItem("templatekot", newTem);
  };

  const handleShowPreparingTimerChange = (checked) => {
    dispatch(setShowPreparingTimer(checked));
    localStorage.setItem("tokenDisplay.showPreparingTimer", checked ? "true" : "false");
  };

  const handleShowHeaderDateTimeChange = (checked) => {
    dispatch(setShowHeaderDateTime(checked));
    localStorage.setItem("tokenDisplay.showHeaderDateTime", checked ? "true" : "false");
  };

  const handleEnableNewsScrollMediaChange = (checked) => {
    dispatch(setEnableNewsScrollMedia(checked));
    localStorage.setItem("tokenDisplay.enableNewsScrollMedia", checked ? "true" : "false");
  };

  const handleNewsScrollItemsChange = (_, values) => {
    const arr = Array.isArray(values) ? values : [];
    const normalized = arr
      .map((x) => (typeof x === "string" ? x : x?.label || x?.value || ""))
      .map((x) => String(x || "").trim())
      .filter(Boolean);
    dispatch(setNewsScrollItems(normalized));
    try {
      localStorage.setItem("tokenDisplay.newsScrollItems", JSON.stringify(normalized));
    } catch (_) {}
  };

  const handleTickerAnimationTypeChange = (newType) => {
    const next = String(newType || "scroll");
    dispatch(setTickerAnimationType(next));
    try {
      localStorage.setItem("tokenDisplay.tickerAnimationType", next);
    } catch (_) {}
  };

  const NEWS_MEDIA_OPTIONS = [
    { group: "Indian", label: "പുഞ്ചിരിയോടെ കാത്തിരിക്കൂ 😊" },
    { group: "Indian", label: "നിങ്ങളുടെ ഓർഡർ ഉടൻ തയ്യാറാകും" },
    { group: "Indian", label: "രുചി തയ്യാറെടുക്കുന്നു 🍽️" },
    { group: "Indian", label: "നല്ല ഭക്ഷണം വരുന്നു" },
    { group: "Indian", label: "കാത്തിരിപ്പ് കുറവാണ്, രുചി കൂടുതലാണ്" },
    { group: "Indian", label: "രുചിക്ക് സമയം വേണം" },
    { group: "Indian", label: "സ്നേഹത്തോടെ പാചകം ചെയ്യുന്നു" },
    { group: "Malayalam", label: "ഓരോ ഓർഡറും പ്രത്യേകമാണ്" },
    { group: "Malayalam", label: "ചൂടോടെ, സ്നേഹത്തോടെ" },
    { group: "Malayalam", label: "വിശപ്പ് സന്തോഷമാകുന്നു ഇവിടെ" },
    { group: "Arabian", label: "Good food is worth the wait." },
    { group: "International", label: "Your order is being prepared with care." },
    { group: "International", label: "Freshly made. Served with love." },
    { group: "International", label: "Happiness is on the way." },
    { group: "International", label: "Cooking happiness for you.." },
    { group: "International", label: "Great taste takes time." },
  ];

  const handleSelectPosDevices = (_, values) => {
    const arr = Array.isArray(values) ? values : [];
    setSelectedDevices(arr);
    const ids = arr.map((d) => d?._id).filter(Boolean);
    dispatch(setSelectedPosDevices(ids));
    // keep single-field for back-compat with any older consumers
    const first = arr[0];
    dispatch(setSelectedPosDevice(first ? { deviceId: first._id, deviceName: first.name || first.deviceName } : { deviceId: null, deviceName: null }));
    try {
      if (ids.length > 0) {
        window.localStorage.setItem("tokenDisplay.posDevices", JSON.stringify(ids));
      } else {
        window.localStorage.removeItem("tokenDisplay.posDevices");
      }
    } catch (_) {}
  };

  const handleFontColorChange = (color) => {
    dispatch(setFontColor(color));
    localStorage.setItem("fontColor", color);
  };

  const handleBackgroundColorChange = (color) => {
    dispatch(setBackgroundColor(color));
    localStorage.setItem("backgroundColor", color);
  };
  const handleBgColorPreChange = (color) => {
    dispatch(setFontBgPreColor(color));
    localStorage.setItem("bgColorPre", color);
  };

  const handlePrepareBGColorChange = (color) => {
    dispatch(setPrepareBg(color));
    localStorage.setItem("prepareBgColor", color);
  };

  const handleReadyBGColorChange = (color) => {
    dispatch(setReadyBgColor(color));
    localStorage.setItem("readyBgColor", color);
  };

  const [prepareBgMediaMeta, setPrepareBgMediaMeta] = useState([]);
  const [readyBgMediaMeta, setReadyBgMediaMeta] = useState([]);

  const loadBgMediaMeta = async (scope, ids) => {
    const safeIds = Array.isArray(ids) ? ids : [];
    const out = [];
    for (const id of safeIds) {
      try {
        const row = await db.tokenColumnBgMedia.get(Number(id));
        if (row) {
          out.push({
            id: row.id,
            name: row.name,
            type: row.type,
            size: row.size,
          });
        }
      } catch (_) {}
    }
    if (scope === "prepare") setPrepareBgMediaMeta(out);
    if (scope === "ready") setReadyBgMediaMeta(out);
  };

  useEffect(() => {
    loadBgMediaMeta("prepare", prepareColumnBgMediaIds);
  }, [prepareColumnBgMediaIds]);

  useEffect(() => {
    loadBgMediaMeta("ready", readyColumnBgMediaIds);
  }, [readyColumnBgMediaIds]);

  const persistBgSetting = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (_) {}
  };

  const handlePrepareColumnBgEnabledChange = (checked) => {
    dispatch(setPrepareColumnBgEnabled(checked));
    persistBgSetting("tokenDisplay.prepareColumnBgEnabled", checked ? "true" : "false");
  };

  const handleReadyColumnBgEnabledChange = (checked) => {
    dispatch(setReadyColumnBgEnabled(checked));
    persistBgSetting("tokenDisplay.readyColumnBgEnabled", checked ? "true" : "false");
  };

  const clampOpacity = (val) => {
    const n = Number(val);
    if (!Number.isFinite(n)) return 30;
    return Math.min(100, Math.max(10, n));
  };

  const handlePrepareColumnBgOpacityChange = (val) => {
    const v = clampOpacity(val);
    dispatch(setPrepareColumnBgOpacity(v));
    persistBgSetting("tokenDisplay.prepareColumnBgOpacity", String(v));
  };

  const handleReadyColumnBgOpacityChange = (val) => {
    const v = clampOpacity(val);
    dispatch(setReadyColumnBgOpacity(v));
    persistBgSetting("tokenDisplay.readyColumnBgOpacity", String(v));
  };

  const clampIntervalMs = (val) => {
    const n = Number(val);
    if (!Number.isFinite(n)) return 6000;
    return Math.min(60000, Math.max(1500, n));
  };

  const handleColumnBgIntervalMsChange = (val) => {
    const v = clampIntervalMs(val);
    dispatch(setColumnBgIntervalMs(v));
    persistBgSetting("tokenDisplay.columnBgIntervalMs", String(v));
  };

  const persistMediaIds = (scope, ids) => {
    const key = scope === "prepare" ? "tokenDisplay.prepareColumnBgMediaIds" : "tokenDisplay.readyColumnBgMediaIds";
    try {
      localStorage.setItem(key, JSON.stringify(ids));
    } catch (_) {}
  };

  const validateBgFiles = (files) => {
    const MAX_BYTES = 50 * 1024 * 1024;
    const accepted = [];
    (Array.isArray(files) ? files : []).forEach((f) => {
      if (!f) return;
      if (f.size > MAX_BYTES) return;
      if (!(String(f.type || "").startsWith("image/") || String(f.type || "").startsWith("video/"))) return;
      accepted.push(f);
    });
    return accepted;
  };

  const handleBgMediaUpload = async (scope, e) => {
    const files = validateBgFiles(Array.from(e?.target?.files || []));
    if (files.length === 0) return;

    const current = scope === "prepare" ? (Array.isArray(prepareColumnBgMediaIds) ? prepareColumnBgMediaIds : []) : (Array.isArray(readyColumnBgMediaIds) ? readyColumnBgMediaIds : []);
    const nextIds = [...current];

    for (const file of files) {
      try {
        const id = await db.tokenColumnBgMedia.add({
          scope,
          name: file.name,
          type: file.type,
          size: file.size,
          createdAt: Date.now(),
          blob: file,
        });
        nextIds.push(id);
      } catch (_) {}
    }

    if (scope === "prepare") {
      dispatch(setPrepareColumnBgMediaIds(nextIds));
      persistMediaIds("prepare", nextIds);
      handlePrepareColumnBgEnabledChange(true);
    } else {
      dispatch(setReadyColumnBgMediaIds(nextIds));
      persistMediaIds("ready", nextIds);
      handleReadyColumnBgEnabledChange(true);
    }

    try {
      e.target.value = "";
    } catch (_) {}
  };

  const handleBgMediaRemove = async (scope, id) => {
    const nId = Number(id);
    if (!Number.isFinite(nId)) return;
    try {
      await db.tokenColumnBgMedia.delete(nId);
    } catch (_) {}

    if (scope === "prepare") {
      const next = (Array.isArray(prepareColumnBgMediaIds) ? prepareColumnBgMediaIds : []).filter((x) => Number(x) !== nId);
      dispatch(setPrepareColumnBgMediaIds(next));
      persistMediaIds("prepare", next);
    } else {
      const next = (Array.isArray(readyColumnBgMediaIds) ? readyColumnBgMediaIds : []).filter((x) => Number(x) !== nId);
      dispatch(setReadyColumnBgMediaIds(next));
      persistMediaIds("ready", next);
    }
  };

  // Order type color handlers
  const handleUseOrderTypeColorsChange = (checked) => {
    dispatch(setUseOrderTypeColors(checked));
    localStorage.setItem("useOrderTypeColors", checked ? "true" : "false");
  };

  const handleDineinColorChange = (color) => {
    dispatch(setDineinColor(color));
    localStorage.setItem("dineinColor", color);
  };

  const handleTakeawayColorChange = (color) => {
    dispatch(setTakeawayColor(color));
    localStorage.setItem("takeawayColor", color);
  };

  const handleDeliveryColorChange = (color) => {
    dispatch(setDeliveryColor(color));
    localStorage.setItem("deliveryColor", color);
  };

  const handleReadyDineinColorChange = (color) => {
    dispatch(setReadyDineinColor(color));
    localStorage.setItem("readyDineinColor", color);
  };

  const handleReadyTakeawayColorChange = (color) => {
    dispatch(setReadyTakeawayColor(color));
    localStorage.setItem("readyTakeawayColor", color);
  };

  const handleReadyDeliveryColorChange = (color) => {
    dispatch(setReadyDeliveryColor(color));
    localStorage.setItem("readyDeliveryColor", color);
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const updatedFiles = [...formData.files];

    newFiles.forEach((newFile) => {
      const duplicateFile = updatedFiles.find(
        (file) => file.name === newFile.name && file.size === newFile.size
      );

      if (!duplicateFile) {
        updatedFiles.push(newFile);
      }
    });

    setFormData((prev) => ({
      ...prev,
      files: updatedFiles,
    }));
  };

  const handleDurationChange = (change) => {
    setFormData((prev) => ({
      ...prev,
      duration: Math.max(1, Math.min(60, prev.duration + change)),
    }));
  };

  const handleDeleteImage = (index, id) => {
    const fileInput = document.getElementById("file-upload");
    fileInput.value = "";
    setFormData((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
      deletedImageIds: [...prev.deletedImageIds, id],
    }));
  };

  const handleBranchChange = (e, value) => {
    setFormData((prev) => ({
      ...prev,
      branch: value,
    }));
  };

  const handleSubmit = () => {
    dispatch(setLoading(true));
    // console.log(formData);
    const formDataToSend = new FormData();

    formDataToSend.append(
      "branchId",
      formData?.branch?._id || branchDetails?._id
    );
    formDataToSend.append("slideInterval", formData?.duration);
    formDataToSend.append(
      "imageIdsToDelete",
      JSON.stringify(formData?.deletedImageIds)
    );

    // Filter files that do not have an _id property
    const filesToAppend = formData.files.filter((file) => !file._id);

    // Append the filtered files to the FormData
    filesToAppend.forEach((file) => formDataToSend.append("file", file));

    // for (const entry of formDataToSend.entries()) {
    //   console.log(entry);
    // }

    const sendBody = {
      body: formDataToSend,
      branchId: branchDetails?._id,
    };
    if (displayAdvertisement) {
      formDataToSend.append("advId", displayAdvertisement?._id);
      updateAdvertisement(sendBody);
    } else {
      uploadAdvertisement(sendBody);
    }
  };

  useEffect(() => {
    if (displayAdvertisement) {
      const advertisementMedia = displayAdvertisement?.imageUrl || [];
      // console.log("ad media--", advertisementMedia);
      const uploadedFiles = [];

      // Create a set to store unique file names
      const uniqueFileNames = new Set(formData.files.map((file) => file.name));

      // Iterate through advertisement media
      advertisementMedia.forEach(async (media) => {
        // Mark the callback function as async
        // Extract file name from URL
        const fileName = media.url.substring(media.url.lastIndexOf("/") + 1);

        // Check if the media is a video
        const isVideo = /\.(mp4|webm|mov|avi|wmv)$/i.test(fileName);

        if (isVideo) {
          // If it's a video, add video icon image
          try {
            const videoIconBlob = await fetch(videoIcon).then((response) =>
              response.blob()
            );
            const videoIconFile = new File(
              [videoIconBlob],
              `video-icon-${fileName}.png`,
              { type: "image/png" }
            );
            videoIconFile._id = media?._id;
            videoIconFile.url = media?.url;
            videoIconFile.format = "video";

            // Add video icon file to uploaded files
            uploadedFiles.push(videoIconFile);
          } catch (error) {
            console.error("Error creating video icon blob:", error);
          }
        } else {
          // If it's not a video, fetch and process image
          try {
            const response = await fetch(media.url);
            const blob = await response.blob();
            // Create a File object from the Blob
            const file = new File([blob], fileName, { type: blob.type });
            file._id = media?._id;
            file.url = media?.url;
            file.format = "image";

            // Update formData state to include the new file
            uploadedFiles.push(file);
          } catch (error) {
            console.error("Error fetching media:", error);
          }
        }
      });

      // Update other formData fields if necessary
      setFormData((prev) => ({
        ...prev,
        branch: allBranchesList.find(
          (res) => res?._id === displayAdvertisement?.branchId
        ),
        selectScreen: displayAdvertisement?.screenType,
        duration: displayAdvertisement?.slideInterval,
        files: uploadedFiles,
      }));
    }
  }, [displayAdvertisement]);

   useEffect(() => {
    const savedTemplate = localStorage.getItem("templatekot");
    const savedFontSize = localStorage.getItem("fontSize");
    const savedFontColor = localStorage.getItem("fontColor");
    const savedBackgroundColor = localStorage.getItem("backgroundColor");
    const savedPrepareBgColor = localStorage.getItem("prepareBgColor");
    const savedReadyBgColor = localStorage.getItem("readyBgColor");
    const savedPreFontBgColor = localStorage.getItem("bgColorPre");

    if (savedTemplate) dispatch(setTemplateKOT(savedTemplate));
    if (savedFontSize) dispatch(setFontSize(savedFontSize));
    if (savedFontColor) dispatch(setFontColor(savedFontColor));
    if (savedBackgroundColor) dispatch(setBackgroundColor(savedBackgroundColor));
    if (savedPrepareBgColor) dispatch(setPrepareBg(savedPrepareBgColor));
    if (savedReadyBgColor) dispatch(setReadyBgColor(savedReadyBgColor));
    if (savedPreFontBgColor) dispatch(setFontBgPreColor(savedPreFontBgColor));
    
    // Load order type colors
    const savedDineinColor = localStorage.getItem("dineinColor");
    const savedTakeawayColor = localStorage.getItem("takeawayColor");
    const savedDeliveryColor = localStorage.getItem("deliveryColor");
    const savedReadyDineinColor = localStorage.getItem("readyDineinColor");
    const savedReadyTakeawayColor = localStorage.getItem("readyTakeawayColor");
    const savedReadyDeliveryColor = localStorage.getItem("readyDeliveryColor");
    
    if (savedDineinColor) dispatch(setDineinColor(savedDineinColor));
    if (savedTakeawayColor) dispatch(setTakeawayColor(savedTakeawayColor));
    if (savedDeliveryColor) dispatch(setDeliveryColor(savedDeliveryColor));
    if (savedReadyDineinColor) dispatch(setReadyDineinColor(savedReadyDineinColor));
    if (savedReadyTakeawayColor) dispatch(setReadyTakeawayColor(savedReadyTakeawayColor));
    if (savedReadyDeliveryColor) dispatch(setReadyDeliveryColor(savedReadyDeliveryColor));
    
    // Load useOrderTypeColors toggle
    const savedUseOrderTypeColors = localStorage.getItem("useOrderTypeColors");
    if (savedUseOrderTypeColors) dispatch(setUseOrderTypeColors(savedUseOrderTypeColors === "true"));

    const savedShowPreparingTimer = localStorage.getItem("tokenDisplay.showPreparingTimer");
    if (savedShowPreparingTimer)
      dispatch(setShowPreparingTimer(savedShowPreparingTimer === "true"));

    const savedShowHeaderDateTime = localStorage.getItem("tokenDisplay.showHeaderDateTime");
    if (savedShowHeaderDateTime)
      dispatch(setShowHeaderDateTime(savedShowHeaderDateTime === "true"));

    const savedEnableNewsScrollMedia = localStorage.getItem("tokenDisplay.enableNewsScrollMedia");
    if (savedEnableNewsScrollMedia)
      dispatch(setEnableNewsScrollMedia(savedEnableNewsScrollMedia === "true"));

    try {
      const savedNewsScrollItems = localStorage.getItem("tokenDisplay.newsScrollItems");
      if (savedNewsScrollItems) {
        const parsed = JSON.parse(savedNewsScrollItems);
        dispatch(setNewsScrollItems(Array.isArray(parsed) ? parsed : []));
      }
    } catch (_) {}

    const savedTickerAnimationType = localStorage.getItem("tokenDisplay.tickerAnimationType");
    if (savedTickerAnimationType) dispatch(setTickerAnimationType(savedTickerAnimationType));
  }, [dispatch]);

  useEffect(() => {
    dispatch(setHideHeader(true));
  }, []);

  const handlePreviewItem = (url, format) => {
    setDialogData({ status: true, url, format });
  };
  const handleClose = () => {
    setDialogData({ status: false, url: null, format: null });
  };

  const handleClearForm = () => {
    const fileInput = document.getElementById("file-upload");
    fileInput.value = "";
    setFormData(initialState);
  };

  return (
    <div
      className="token-display-advertisement-container"
      style={{ padding: "0px" }}
    >
      <div className="token-advertisement-wrapper">
        {/* expand */}

        {/* update  */}
        {!isEditAdv && !advertisementExpand && (
          <div
            className="token-expand-btn update-adv"
            style={{ transform: "100%" }}
          >
            <div style={{ left: "100%" }}>
              <button onClick={() => dispatch(setIsEditAdv(!isEditAdv))}>
                <EditIcon />
              </button>
            </div>
          </div>
        )}
        {/* close */}
        {/* {
          <div className="token-expand-btn close-adv">
            <div>
              <button
                onClick={() =>{
                  dispatch(switch_to_billing_screen({ billingBoolean: false }))
                  navigate("/userdashboard/dashboardhome")
                  dispatch(setHideHeader(false));

                }
                }
              >
                <HighlightOffIcon color="error" />
              </button>
            </div>
          </div>
        } */}

        {userRole === "admin" ? (
          <div className="advertisement-card" style={{ padding: "0 1px" }}>
            <div className="adv-branch-selector-cntr">
              <Autocomplete
                id="tags-outlined"
                options={allBranchesList || []}
                getOptionLabel={(option) =>
                  `${option?.storeCode}-${option?.branchName}`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Branch"
                    value={formData?.branch}
                  />
                )}
                onChange={handleBranchChange}
                value={formData?.branch}
                filterOptions={(options, state) => {
                  const filteredOptions = options.filter(
                    (option) =>
                      option?.branchName
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase()) ||
                      option?.storeCode
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                  );

                  return filteredOptions.filter(
                    (option) => formData.branch?._id !== option?._id
                  );
                }}
              />
            </div>
            {/* <div>
              {displayAdvertisement && (
                <Carousel
                  items={displayAdvertisement?.imageUrl}
                  duration={displayAdvertisement?.slideInterval * 1000}
                />
              )}
            </div> */}
          </div>
        ) : (
          <div className="advertisement-card">
            <div>
              {displayAdvertisement && !isEditAdv && branchDetails && (
                <Carousel
                  items={displayAdvertisement?.imageUrl}
                  duration={displayAdvertisement?.slideInterval * 1000}
                />
              )}
            </div>
          </div>
        )}

        {/* upload advertisement */}
        {isEditAdv && (
          <div className="add-advertisement-card">
            <div className="upload-add-header">
              {/* <span>ADS UPLOAD</span> */}
              <div className="token-display-advertisement-action-button" style={{width:"100%",justifyContent:"start"}}>
                {/* <div className="color-panel-container" style={{ textAlign: "end" }}>
                  <div>
                    <label htmlFor="font-color-select" style={{ padding: "0 5px" }}>Prepare BG:</label>
                    <input
                      type="color"
                      id="font-color-select"
                      value={fontColor}
                      onChange={(e) => handlePrepareBGColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                  <div>
                    <label htmlFor="background-color-select" style={{ padding: "0 5px" }}>Ready BG:</label>
                    <input
                      type="color"
                      id="background-color-select"
                      value={backgroundColor}
                      onChange={(e) => handleReadyBGColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                </div>
                <div className="color-panel-container" style={{ textAlign: "end" }}>
                  <div>
                    <label htmlFor="font-color-select" style={{ padding: "0 5px" }}>Font Color:</label>
                    <input
                      type="color"
                      id="font-color-select"
                      value={fontColor}
                      onChange={(e) => handleFontColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                  <div>
                    <label htmlFor="background-color-select" style={{ padding: "0 5px" }}>Font BG:</label>
                    <input
                      type="color"
                      id="background-color-select"
                      value={backgroundColor}
                      onChange={(e) => handleBackgroundColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                </div> */}
                
                <div className="font-size-selector-container" >
                  <label htmlFor="font-size-select" style={{ padding: "0 5px" }}>Font:</label>
                  <select
                    style={{ padding: "6px" }}
                    id="font-size-select"
                    value={fontSize}
                    onChange={(e) => handleFontSizeChange(e.target.value)}
                    className="font-size-selector"
                  >
                    <option value="medium">Medium</option>
                    <option value="large">Large</option>
                    <option value="xlarge">Extra Large</option>
                  </select>
                </div>

                {/* POS Device selection for Token Display (multi) */}
                <div className="font-size-selector-container" style={{ marginLeft: 12, display:'flex', alignItems:'center' }}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    size="small"
                    disableClearable
                    clearIcon={null}
                    options={(() => {
                      let localStorageDevices = [];
                      try {
                        const saved = window.localStorage.getItem("branchSettings.posDevices");
                        if (saved) localStorageDevices = JSON.parse(saved);
                      } catch (e) {}
                      return [...(fullBranchSettings?.posDevices || []), ...(Array.isArray(branchPosConfigurations?.posDevices) ? branchPosConfigurations.posDevices : []), ...(Array.isArray(billingConfig?.posDevices) ? billingConfig.posDevices : []), ...(Array.isArray(posSettings?.posDevices) ? posSettings.posDevices : []), ...localStorageDevices].filter(Boolean).reduce((acc, cur) => { const id = cur?._id || cur?.id; if (!id) return acc; if (!acc.some((x)=> (x?._id || x?.id) === id)) acc.push(cur); return acc; }, []);
                    })()}
                    getOptionLabel={(opt) => opt?.name || opt?.deviceName || "POS Device"}
                    isOptionEqualToValue={(option, value) => (option?._id || option?.id) === (value?._id || value?.id)}
                    value={selectedDevices}
                    onChange={handleSelectPosDevices}
                    sx={{ minWidth: 220, '& .MuiInputBase-root': { height: 36 }, '& .MuiAutocomplete-clearIndicator': { display: 'none' }, '& .MuiAutocomplete-endAdornment': { right: 6 } }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={option?._id || index}
                          size="small"
                          label={option?.name || option?.deviceName || 'POS'}
                          sx={{ height: 22, '& .MuiChip-label': { px: 0.5 } }}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField {...params} placeholder="POS Devices" />
                    )}
                  />
                </div>

                <button
                  type="clear-advertisement"
                  onClick={() => handleClearForm()}
                >
                  CLEAR
                </button>
                {loading ? (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <button
                    type="update-advertisement"
                    onClick={() => handleSubmit()}
                  >
                    UPDATE
                  </button>
                )}
           
              </div>
              {enableNewsScrollMedia && (
                <div style={{ marginTop: 8, display: "flex", alignItems: "center" }}>
                  <Autocomplete
                    multiple
                    freeSolo
                    size="small"
                    options={NEWS_MEDIA_OPTIONS}
                    groupBy={(option) => (typeof option === "string" ? "Custom" : option?.group || "Other")}
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.label || "")}
                    isOptionEqualToValue={(option, value) => {
                      const optionLabel = typeof option === "string" ? option : option?.label;
                      const valueLabel = typeof value === "string" ? value : value?.label;
                      return String(optionLabel || "") === String(valueLabel || "");
                    }}
                    value={Array.isArray(newsScrollItems) ? newsScrollItems : []}
                    onChange={handleNewsScrollItemsChange}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select / type news media" />
                    )}
                    sx={{ minWidth: 420 }}
                  />
                </div>
              )}

              {enableNewsScrollMedia && (
                <div style={{ marginTop: 8, display: "flex", alignItems: "center" }}>
                  <TextField
                    select
                    size="small"
                    label="Ticker Animation"
                    value={tickerAnimationType || "scroll"}
                    onChange={(e) => handleTickerAnimationTypeChange(e.target.value)}
                    sx={{ minWidth: 220 }}
                  >
                    <MenuItem value="scroll">Scroll</MenuItem>
                    <MenuItem value="smooth">Smooth</MenuItem>
                    <MenuItem value="wave">Wave</MenuItem>
                    <MenuItem value="fade">Fade</MenuItem>
                    <MenuItem value="blast">Blast</MenuItem>
                    <MenuItem value="flash">Flash (No Scroll)</MenuItem>
                  </TextField>
                </div>
              )}
                  <div className="font-size-selector-container" style={{marginTop:"10px", display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap"}} >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label htmlFor="font-size-select" style={{ padding: "0 5px" }}>Display Model:</label>
                    <select
                      style={{ padding: "6px" }}
                      id="font-size-select"
                      value={templatekot}
                      onChange={(e) => handleTemplateChange(e.target.value)}
                      className="font-size-selector"
                    >
                      <option value="classic">Classic</option>
                      <option value="modern">Modern</option>
                    </select>
                  </div>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showPreparingTimer}
                        onChange={(e) => handleShowPreparingTimerChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label="Timer"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showHeaderDateTime}
                        onChange={(e) => handleShowHeaderDateTimeChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={(
                      <span style={{ textAlign: "center", lineHeight: 1.05 }}>
                        DATE
                        <br />
                        &amp;
                        <br />
                        TIME
                      </span>
                    )}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={enableNewsScrollMedia}
                        onChange={(e) => handleEnableNewsScrollMediaChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label={(
                      <span style={{ textAlign: "center", lineHeight: 1.05 }}>
                        news
                        <br />
                        scroll
                        <br />
                        media
                      </span>
                    )}
                  />
                </div>

                <div style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                  <div style={{ fontWeight: "bold", fontSize: 12, marginBottom: 8 }}>Preparing / Ready Background Media</div>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={prepareColumnBgEnabled}
                            onChange={(e) => handlePrepareColumnBgEnabledChange(e.target.checked)}
                            size="small"
                          />
                        }
                        label="Preparing BG"
                      />
                      <input
                        id="prepare-column-bg-upload"
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        onChange={(e) => handleBgMediaUpload("prepare", e)}
                        style={{ display: "none" }}
                      />
                      <label htmlFor="prepare-column-bg-upload" style={{ cursor: "pointer", fontSize: 12, color: "#1976d2" }}>
                        Upload
                      </label>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 11 }}>Opacity</span>
                        <input
                          type="range"
                          min={10}
                          max={100}
                          value={clampOpacity(prepareColumnBgOpacity)}
                          onChange={(e) => handlePrepareColumnBgOpacityChange(e.target.value)}
                        />
                        <span style={{ fontSize: 11 }}>{clampOpacity(prepareColumnBgOpacity)}</span>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={readyColumnBgEnabled}
                            onChange={(e) => handleReadyColumnBgEnabledChange(e.target.checked)}
                            size="small"
                          />
                        }
                        label="Ready BG"
                      />
                      <input
                        id="ready-column-bg-upload"
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        onChange={(e) => handleBgMediaUpload("ready", e)}
                        style={{ display: "none" }}
                      />
                      <label htmlFor="ready-column-bg-upload" style={{ cursor: "pointer", fontSize: 12, color: "#1976d2" }}>
                        Upload
                      </label>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 11 }}>Opacity</span>
                        <input
                          type="range"
                          min={10}
                          max={100}
                          value={clampOpacity(readyColumnBgOpacity)}
                          onChange={(e) => handleReadyColumnBgOpacityChange(e.target.value)}
                        />
                        <span style={{ fontSize: 11 }}>{clampOpacity(readyColumnBgOpacity)}</span>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 11 }}>Slide(ms)</span>
                      <input
                        type="number"
                        value={clampIntervalMs(columnBgIntervalMs)}
                        onChange={(e) => handleColumnBgIntervalMsChange(e.target.value)}
                        style={{ width: 90, padding: "4px 6px" }}
                      />
                    </div>
                  </div>

                  {(prepareBgMediaMeta.length > 0 || readyBgMediaMeta.length > 0) && (
                    <div style={{ marginTop: 10, display: "flex", gap: 18, flexWrap: "wrap" }}>
                      <div style={{ minWidth: 260 }}>
                        <div style={{ fontWeight: "bold", fontSize: 11, marginBottom: 6 }}>Preparing files</div>
                        {prepareBgMediaMeta.map((m) => (
                          <div key={m.id} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 11, padding: "3px 0" }}>
                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 200 }}>
                              {m.name}
                            </div>
                            <button type="button" onClick={() => handleBgMediaRemove("prepare", m.id)} style={{ fontSize: 11 }}>
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                      <div style={{ minWidth: 260 }}>
                        <div style={{ fontWeight: "bold", fontSize: 11, marginBottom: 6 }}>Ready files</div>
                        {readyBgMediaMeta.map((m) => (
                          <div key={m.id} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 11, padding: "3px 0" }}>
                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 200 }}>
                              {m.name}
                            </div>
                            <button type="button" onClick={() => handleBgMediaRemove("ready", m.id)} style={{ fontSize: 11 }}>
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              
              {/* Order Type Colors - Only for Modern theme */}
              {templatekot === "modern" && (
                <div style={{ marginTop: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={useOrderTypeColors}
                        onChange={(e) => handleUseOrderTypeColorsChange(e.target.checked)}
                        size="small"
                      />
                    }
                    label="Use separate colors for order types"
                  />
                  
                  {useOrderTypeColors && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginTop: "10px" }}>
                      {/* Preparing Colors */}
                      <div style={{ border: "1px solid #eee", padding: "8px", borderRadius: "4px" }}>
                        <div style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "12px" }}>Preparing Colors</div>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Dine-in:</label>
                            <input
                              type="color"
                              value={dineinColor || "#994529"}
                              onChange={(e) => handleDineinColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Takeaway:</label>
                            <input
                              type="color"
                              value={takeawayColor || "#1976d2"}
                              onChange={(e) => handleTakeawayColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Delivery:</label>
                            <input
                              type="color"
                              value={deliveryColor || "#388e3c"}
                              onChange={(e) => handleDeliveryColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </div>
                      
                      {/* Ready Colors */}
                      <div style={{ border: "1px solid #eee", padding: "8px", borderRadius: "4px" }}>
                        <div style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "12px" }}>Ready Colors</div>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Dine-in:</label>
                            <input
                              type="color"
                              value={readyDineinColor || "#186734"}
                              onChange={(e) => handleReadyDineinColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Takeaway:</label>
                            <input
                              type="color"
                              value={readyTakeawayColor || "#1565c0"}
                              onChange={(e) => handleReadyTakeawayColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <label style={{ fontSize: "11px", marginRight: "5px" }}>Delivery:</label>
                            <input
                              type="color"
                              value={readyDeliveryColor || "#2e7d32"}
                              onChange={(e) => handleReadyDeliveryColorChange(e.target.value)}
                              style={{ width: "25px", height: "25px", border: "none", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              
              <div style={{display:"flex",justifyContent:"space-evenly",paddingTop:"10px"}}>
              <div className="color-panel-container" style={{ textAlign: "end" }}>
                  <div>
                    <label htmlFor="font-color-select" style={{ padding: "0 5px" }}>Prepare BG:</label>
                    <input
                      type="color"
                      id="font-color-select"
                      value={prepareBG}
                      onChange={(e) => handlePrepareBGColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                  <div>
                    <label htmlFor="background-color-select" style={{ padding: "0 5px" }}>Ready BG:</label>
                    <input
                      type="color"
                      id="background-color-select"
                      value={readyBG}
                      onChange={(e) => handleReadyBGColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                </div>
                <div className="color-panel-container" style={{ textAlign: "end" }}>
                  <div>
                    <label htmlFor="font-color-select" style={{ padding: "0 5px" }}>tokenFont & Pre-Ready BG:</label>
                    <input
                      type="color"
                      id="font-color-select"
                      value={fontColor}
                      onChange={(e) => handleFontColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                  <div>
                    <label htmlFor="background-color-select" style={{ padding: "0 5px" }}>Font Ready BG:</label>
                    <input
                      type="color"
                      id="background-color-select"
                      value={backgroundColor}
                      onChange={(e) => handleBackgroundColorChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                  <div>
                    <label htmlFor="background-color-select" style={{ padding: "0 5px" }}>Font Prepare BG:</label>
                    <input
                      type="color"
                      id="background-color-select"
                      value={prepareFontBG}
                      onChange={(e) => handleBgColorPreChange(e.target.value)}
                      style={{ width: "30px", height: "30px", border: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="adv-file-upload-cntr">
              <div className="ticket-advertisement-image-upload-container">
                <div className="image-name-container">
                  <span>
                    {formData.image
                      ? formData.image.name
                      : "Upload image / video"}
                  </span>
                </div>
                <div className="upload-add-image-button-container">
                  <label htmlFor="file-upload" className="custom-file-upload">
                    <UploadImageSvg />
                    &nbsp; Upload
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    accept="image/*,video/*"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    multiple
                  />
                </div>
              </div>
              <div className="ticket-advertisement-image-upload-container adv-duration-cntr">
                <div>
                  <QueryBuilderIcon color="info" />
                </div>
                <input
                  type="number"
                  name="duration"
                  id="duration"
                  value={formData.duration}
                  readOnly
                />
                <div className="advr-in-de-btn-cntr">
                  <IconButton
                    aria-label="increase duration"
                    onClick={() => handleDurationChange(1)}
                  >
                    <ArrowDropUpIcon />
                  </IconButton>
                  <IconButton
                    aria-label="decrease duration"
                    onClick={() => handleDurationChange(-1)}
                  >
                    <ArrowDropDownIcon />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className="adv-upload-img-preview-cntr">
              {formData?.files?.map((file, index) => (
                <div
                  key={index}
                  className="ticket-advertisement-image-upload-container"
                >
                  <div
                    className="adv-prev-img"
                    onClick={() => handlePreviewItem(file.url, file.format)}
                  >
                    {file.type.startsWith("image/") ? (
                      <img src={URL.createObjectURL(file)} alt={file.name} />
                    ) : file.type.startsWith("video/") ? (
                      // Render video thumbnail if it's a video file
                      <video controls>
                        <source
                          src={URL.createObjectURL(file)}
                          type={file.type}
                        />
                      </video>
                    ) : (
                      <span>Unsupported file type</span>
                    )}
                  </div>
                  <div className="">{file.name}</div>
                  <div className="adv-dlt-cntr">
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleDeleteImage(index, file._id)}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <MediaDialog dialogData={dialogData} handleClose={handleClose} />
    </div>
  );
};

export default AdvertisementCard;

// -----------------------------------------------

export const SquareComponent = ({ squares, selectedScreen }) => {
  const getSquareStyle = (index) => {
    switch (squares) {
      case 1:
        return { width: "100%", height: "100%" };
      case 2:
        return { width: "100%", height: "48%" };
      case 3:
        return { width: "100%", height: `calc(92% / 3)` };
      case 4:
        return { width: "48%", height: "48%" };
      default:
        return { width: "auto", height: "auto" };
    }
  };

  return (
    <div
      className="outer-square"
      style={{ "--border-color": selectedScreen === squares && "#000000" }}
    >
      {[...Array(squares)].map((_, i) => (
        <Fragment key={i}>
          <div
            className={`inner-square ${i === 1 ? "top-left" : i === 2 ? "top-right" : ""
              }`}
            style={getSquareStyle(i)}
          >
            {" "}
            <ImageOutlinedIcon
              sx={{ color: selectedScreen === squares ? "#000000" : "#c5c5c5" }}
            />
          </div>
          <div
            className={`inner-square ${i === 1 ? "bottom-left" : i === 2 ? "bottom-right" : ""
              }`}
            style={getSquareStyle(i)}
          >
            {" "}
            <ImageOutlinedIcon
              sx={{ color: selectedScreen === squares ? "#000000" : "#c5c5c5" }}
            />
          </div>
          {squares === 3 && (
            <div className={`inner-square center `} style={getSquareStyle(i)}>
              {" "}
              <ImageOutlinedIcon
                sx={{
                  color: selectedScreen === squares ? "#000000" : "#c5c5c5",
                }}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};
